__turbopack_context__.v({
  "className": "chessfont_ba914efd-module__vqt0bq__className",
});
